export default "__VITE_ASSET__5129808f__"